import { render, staticRenderFns } from "./WarehouseItems.vue?vue&type=template&id=09176b1c&scoped=true&"
import script from "./WarehouseItems.vue?vue&type=script&lang=js&"
export * from "./WarehouseItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09176b1c",
  null
  
)

export default component.exports